import { Box, Dialog, Slide } from '@mui/material';
import React from 'react';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const MLDialog = ({ openDialog, setOpenDialog, classList, children }) => {
  return (
    <Dialog
      fullScreen
      open={openDialog}
      onClose={() => setOpenDialog(false)}
      // TransitionComponent={Transition}
      className={classList}
    >
      <div className="flex-1 flex h-full">{children}</div>
    </Dialog>
  );
};

export default MLDialog;
